import { logger } from '../../../logger/index.ts';
import { MiseFile } from './schema.ts';

export function parseTomlFile(
  content: string,
  packageFile: string,
): MiseFile | null {
  const res = MiseFile.safeParse(content);
  if (res.success) {
    return res.data;
  }
  logger.debug({ err: res.error, packageFile }, 'Error parsing Mise file.');
  return null;
}
